export const DeviceType = {
    ANDROID: 0,
    IOS: 1,
    WINDOWS_PC: 2,
    MAC: 3,
    WEB: 4,
}
